import './hero-navigation.scss';
import Component from '../component/component';

export default class HeroNavigation extends Component {
    static initSelector: string = '.hero-navigation:not(.hero-navigation--grid)';

    constructor(target: HTMLElement) {
        super(target);

        this.init();
    }

    init(): void {
        this.setupEventListeners();
    }

    setupEventListeners(): void {
        const navigationLinks: JQuery<HTMLElement> = this.element.find('.hero-navigation__link, .dropdown__link');

        navigationLinks.each((index: number, link: HTMLElement): void => {
            $(link).on('click', this.handleNavigationLinkClick.bind(this));
        });
    }

    handleNavigationLinkClick(event: Event): void {
        event.preventDefault();

        const targetHref: string | undefined = (event.target as HTMLElement).getAttribute('href');
        const targetId: string | undefined = targetHref ? targetHref.substring(1) : undefined;
        const targetElement: HTMLElement | null = document.getElementById(targetId || '');

        if (targetElement) {
            this.smoothScrollTo(targetElement);
        }
    }

    smoothScrollTo(target: HTMLElement): void {
        const startPosition: number = window.pageYOffset;
        const targetPosition: number = target.getBoundingClientRect().top + startPosition;
        const startTime: number = performance.now();
        const duration: number = 500;

        const scrollStep: (timestamp: number) => void = (timestamp: number): void => {
            const currentTime: number = timestamp || performance.now();
            const progress: number = Math.min((currentTime - startTime) / duration, 1);

            const offset: number = 100;
            const adjustedTargetPosition: number = targetPosition - offset;

            window.scrollTo(0, startPosition + (adjustedTargetPosition - startPosition) * progress);

            if (progress < 1) {
                requestAnimationFrame(scrollStep);
            }
        };

        requestAnimationFrame(scrollStep);
    }
}
